// regular load
export const ROWS_PER_STATUS = 50;
// export related - total length limit
export const MAX_LENGTH_TO_DOWNLOAD = 10000;
// for export all - limit how many rows per status
export const EXPORT_ROWS_PER_STATUS = 1000;
